import { FC } from "react"
import { useTranslation } from "react-i18next"
import { FilterButton, FilterClearButton } from "./FilterButton";



interface ILotsByGoodsFilterProps {
    nameButton: string
    isOpen: boolean
    onOpenChange:() => void
}
interface ILotsByGoodsFilterClearProps {
    nameButton: string
    isOpen: boolean
    onClick: () => void
}

export const LotsByGoodsFilterButtons: FC<ILotsByGoodsFilterProps> = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <FilterButton
                nameButton={props.nameButton}
                isOpen={props.isOpen}
                onOpenChange={() => props.onOpenChange()}
                
            />
        </>
    )
}
export const LotsByGoodsFilterClearButtons: FC<ILotsByGoodsFilterClearProps> = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <FilterClearButton
                nameButton={props.nameButton}
                isOpen={props.isOpen}
                onClick={props.onClick}
            />
        </>
    )
}
